// extracted by mini-css-extract-plugin
export var OnOffButton = "OnOffButton-module--OnOffButton--M4cRT";
export var pin = "OnOffButton-module--pin--v01Wd";
export var uActive = "OnOffButton-module--uActive--cEQ8w";
export var uDisabled = "OnOffButton-module--uDisabled--vKC7D";